import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';

interface UserInfo {
  name: string;
  email: string;
  initials: string;
}

function getUserInfoFromToken(idTokenPayload: any) {
  const name = `${idTokenPayload?.given_name} ${idTokenPayload?.family_name}`;

  return {
    name,
    email: idTokenPayload?.email,
    initials: name.trim().split(' ').map(part => part[0]).join(''),
  };
}

export function useUserInfo() {
  const { user } = useAuth();
  const idTokenPayload = user?.profile;

  const [userInfo, setUserInfo] = useState<UserInfo>(getUserInfoFromToken(idTokenPayload));

  useEffect(() => {
    if (!idTokenPayload)
      return;
    setUserInfo(getUserInfoFromToken(idTokenPayload));
  }, [idTokenPayload]);

  return userInfo;
}
